/**
 * Created by zuozhuo on 2018/1/29.
 */
export default {
  debugMode: false,

  // ajax 请求前缀, 统一为 /api, 不许更改
  baseUrl: "https://api.lxeap.net/api",
  // 是否开启POST请求数据加密, 测试环境不开, 正式环境开启
  encodeAjaxData: true,

  wx_appid: "wx625309623a767168",
  wx_code_auth_api: "https://api.lxeap.net/api/auth/wechat",
  emoji_static_domain: "https://image.lxeap.cn/images/face/",
  rongyun_key: "lmxuhwaglifed",

  zhuge_app_key: "1963f16bf5854a4f96dbe30d734eae1a",
  zhuge_app_id: "52"
};



// WEBPACK FOOTER //
// ./src/consts/config/index.js